import { memo } from "react";
import type { ActiveInspectionRegister } from "../InspectionsLists.d";
import { useDate } from "@/hooks/use-date/useDate";
import PhasePill from "../phase-pill/PhasePill";
import InspectionAcitivities from "./InspectionActivities";
import StandMotorData from "./StandMotorData";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import CardDataLine from "./CardDataLine";

export interface ActiveInspectionCardProps {
  inspectionData: ActiveInspectionRegister;
  getNoSortedInspections: () => void;
}

const ActiveInspectionCard = ({
  inspectionData,
  getNoSortedInspections,
}: ActiveInspectionCardProps) => {
  const translate = useTranslate();
  const { formatDate, getDaysSince } = useDate();

  return (
    <div className="w-full px-6 py-4 border border-ib-gray-lightest bg-ib-white">
      <div className="w-full flex flex-row justify-between items-center h-[32px] mb-2">
        <PhasePill phaseName={inspectionData.phase.name || ""} />
        <InspectionAcitivities
          inspectionId={inspectionData.id}
          standNumber={inspectionData.snStand}
          getNoSortedInspections={getNoSortedInspections}
        />
      </div>
      <div className="w-full flex flex-row gap-x-6 pb-2 border-b border-b-ib-gray-borders mb-4">
        <StandMotorData
          label={translate("snStand")}
          value={inspectionData.snStand}
        />
        <StandMotorData
          label={translate("engine")}
          value={inspectionData.engineName}
        />
      </div>
      <div className="w-full flex flex-col gap-0.5">
        <CardDataLine
          label={translate("startDate")}
          value={{
            date: formatDate(inspectionData.createdAt),
            period: getDaysSince(inspectionData.createdAt),
          }}
        />
        <CardDataLine label={translate("esnIn")} value={inspectionData.esnIn} />
        <CardDataLine
          label={translate("colour")}
          value={inspectionData.colour}
        />
      </div>
    </div>
  );
};

export default memo(ActiveInspectionCard);
